import React, { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { ParagraphText, StackLayout } from '@leagueplatform/genesis-core';
import { FormsCenterMasonryGrid } from 'components/forms-center/forms-center-masonry-grid.component';
import { sendFormsCenterScreenLoadedEvent } from 'utils/analytics-events';

const FormsCenterLandingPage = () => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_FORMS_CENTER' }));

  useEffect(() => {
    sendFormsCenterScreenLoadedEvent();
  }, []);

  return (
    <MainPageContainer width="100%">
      <HeroSection title={formatMessage({ id: 'STR_FORMS_CENTER' })} />
      <StackLayout
        css={{
          maxWidth: 1048,
        }}
      >
        <ParagraphText emphasis="subtle">
          {formatMessage({ id: 'STR_FORMS_CENTER_SUBTITLE' })}
        </ParagraphText>
        <FormsCenterMasonryGrid />
      </StackLayout>
    </MainPageContainer>
  );
};

export default FormsCenterLandingPage;
